
import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/integrations/supabase/client";
import { Auth as SupabaseAuth } from "@supabase/auth-ui-react";
import { ThemeSupa } from "@supabase/auth-ui-shared";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

const Auth = () => {
  const { user, loading } = useAuth();
  const [activeTab, setActiveTab] = useState<"sign-in" | "sign-up">("sign-in");

  // If authenticated, redirect to dashboard
  if (!loading && user) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="h-screen flex flex-col items-center justify-center p-4 bg-gray-50 dark:bg-gray-900">
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <h1 className="text-3xl font-bold">Brain 🧠</h1>
          <p className="text-muted-foreground">Your personal knowledge base</p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Welcome to Brain</CardTitle>
            <CardDescription>
              Sign in to access your personal knowledge base
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Tabs defaultValue={activeTab} onValueChange={(v) => setActiveTab(v as "sign-in" | "sign-up")}>
              <TabsList className="grid w-full grid-cols-2 mb-4">
                <TabsTrigger value="sign-in">Sign In</TabsTrigger>
                <TabsTrigger value="sign-up">Sign Up</TabsTrigger>
              </TabsList>
              <TabsContent value="sign-in">
                <SupabaseAuth
                  supabaseClient={supabase}
                  appearance={{ 
                    theme: ThemeSupa,
                    variables: {
                      default: {
                        colors: {
                          brand: 'rgb(59, 130, 246)',
                          brandAccent: 'rgb(29, 78, 216)',
                        },
                      },
                    }, 
                  }}
                  providers={["google"]}
                  view={activeTab === "sign-in" ? "sign_in" : "sign_up"}
                  redirectTo={window.location.origin}
                />
              </TabsContent>
              <TabsContent value="sign-up">
                <SupabaseAuth
                  supabaseClient={supabase}
                  appearance={{ 
                    theme: ThemeSupa,
                    variables: {
                      default: {
                        colors: {
                          brand: 'rgb(59, 130, 246)',
                          brandAccent: 'rgb(29, 78, 216)',
                        },
                      },
                    }, 
                  }}
                  providers={["google"]}
                  view={"sign_up"}
                  redirectTo={window.location.origin}
                />
              </TabsContent>
            </Tabs>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Auth;
